import React from 'react';
import { useSystemAcl } from '../hooks/use-system-acl.js';
import SystemAclPageView from './system-acl-page-view.jsx';

function SystemAclPageContainer() {
  const state = useSystemAcl();
  return <SystemAclPageView {...state} />;
}

export default SystemAclPageContainer;
